module.exports = __webpack_public_path__ + "img/seven.c3d7c7b2.png";